import { apiAxiosQuatro } from "./appAxios";
import { tokenFunc } from "./tokenService";

// Bildirim hub'ı API köküne bağlıdır (/api yok), panik uyarılarıyla aynı hub'dır.
export const NOTIFICATION_HUB_URL = `${apiAxiosQuatro.defaults.baseURL.replace(/\/api\/?$/, "")}/hubs/notifications`;

// Araç sahibi uçları sarmalanmamış (raw) JSON döner
const ownerCall = async (method, url, { params, data } = {}) => {
  try {
    const res = await apiAxiosQuatro.request({
      method,
      url,
      params,
      data,
      headers: { Authorization: await tokenFunc() },
    });
    return { status: true, data: res.data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.message || error?.message,
    };
  }
};

// Admin uçları { success, data } ile sarmalıdır
const adminCall = async (url, params) => {
  try {
    const { data } = await apiAxiosQuatro.get(url, {
      params,
      headers: { Authorization: await tokenFunc() },
    });
    return { status: true, data: data?.data };
  } catch (error) {
    return {
      status: false,
      statusCode: error?.response?.status || 500,
      message: error?.response?.data?.message || error?.message,
    };
  }
};

// ---- Araç sahibi ----
export const getMyNotificationsService = (params) => ownerCall("get", `/Notifications/My`, { params });
export const getUnreadNotificationCountService = () => ownerCall("get", `/Notifications/UnreadCount`);
export const markNotificationReadService = (id) => ownerCall("post", `/Notifications/MarkRead/${id}`);
export const markAllNotificationsReadService = () => ownerCall("post", `/Notifications/MarkAllRead`);
export const deleteNotificationService = (id) => ownerCall("delete", `/Notifications/Delete/${id}`);
export const deleteManyNotificationsService = (ids) => ownerCall("post", `/Notifications/DeleteMany`, { data: { ids } });
export const deleteAllNotificationsService = (onlyRead = false) =>
  ownerCall("post", `/Notifications/DeleteAll`, { params: { onlyRead } });

// ---- Admin ----
export const getAdminNotificationListService = (params) => adminCall(`/NotificationsAdmin/GetList`, params);
export const getAdminNotificationSummaryService = () => adminCall(`/NotificationsAdmin/GetSummary`);

// Sayaç/liste değiştiğinde zil ile sayfa birbirini haberdar eder
export const NOTIFICATIONS_CHANGED_EVENT = "quatro:notifications-changed";
export const emitNotificationsChanged = () => window.dispatchEvent(new CustomEvent(NOTIFICATIONS_CHANGED_EVENT));
